import { render, staticRenderFns } from "./ContactForm.vue?vue&type=template&id=2a0f7d82&scoped=true&"
import script from "./ContactForm.vue?vue&type=script&lang=js&"
export * from "./ContactForm.vue?vue&type=script&lang=js&"
import style0 from "./ContactForm.vue?vue&type=style&index=0&id=2a0f7d82&scoped=true&lang=css&"
import style1 from "./ContactForm.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a0f7d82",
  null
  
)

export default component.exports